<template>
  <div class="admin-container">
    <nav class="navbar">
      <div class="side-buttons">
        <button class="side-button-back" @click="goBack">Back</button>
        <button class="side-button-logout" @click="logout">Logout</button>
      </div>

      <div class="navbar-container">
        <router-link to="/admin/general">General Settings</router-link>
        <router-link to="/admin/workers">Workers</router-link>
        <router-link to="/admin/system">System</router-link>
        <router-link to="/admin/slack">Slack</router-link>
      </div>
    </nav>

    <div class="container">
      <router-view />
    </div>
  </div>
</template>

<script>
import authService from "@/services/authService";

export default {
  name: 'AdminView',
  methods: {
    goBack() {
      this.$router.push('/');
    },
    async logout() {
      await authService.logout();
      await this.$router.push('/');
    }
  }
}
</script>

<style scoped>
.admin-container {
  width: 100%;
}

.container {
  width: 100%;
}

.navbar {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 10px;
}

.navbar-container {
  display: flex;
  justify-content: center;
  flex-grow: 1;
}

.navbar a {
  text-decoration: none;
  color: #007bff;
  margin: 10px;
  text-align: center;
}

.side-buttons {
  display: flex;
  gap: 10px;
  position: absolute;
}

.side-button-back {
  background-color: #dfdfdf;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.side-button-back:hover {
  background-color: #ccc;
}

.side-button-back:focus {
  outline: none;
}

.side-button-logout {
  background-color: #dfdfdf;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.side-button-logout:hover {
  background-color: #ff4d4d;
}

.side-button-logout:focus {
  outline: none;
}

@media (max-width: 700px) {
  .navbar{
    flex-direction: column;
  }
  .side-buttons{
    position: relative;
  }
}
</style>
